import { useState } from "react";
import PageHeading from "../../PageHeading";
import PathologyAgentList from "./PathologyAgent/PathologyAgentList";
import PathologyManager from "./PathologyTest/PathologyTest";
import PathologyCategoryList from "./PathologyCategory";
import PathologyPerformerList from "./PathologyPerformerList";

const PathologyConfig = () => {
  const [activeTab, setActiveTab] = useState("Agent");

  const tabs = [
    {
      name: "Test",
      content: (
        <div className="tab-content">
          <PathologyManager />
        </div>
      ),
    },
    {
      name: "Agent",
      content: (
        <div className="tab-content">
          <PathologyAgentList />
        </div>
      ),
    },
    {
      name: "Category",
      content: (
        <div className="tab-content">
          <PathologyCategoryList />
        </div>
      ),
    },
    {
      name: "Performer",
      content: (
        <div className="tab-content">
          <PathologyPerformerList />
        </div>
      ),
    }
  ];

  const breadcrumbs = [
    { label: "Dashboard", url: "/" },
    { label: "Pathology" },
    { label: "Pathology Config" },
  ];

  return (
    <div>
      <div className="print-hidden">
        <PageHeading title="Pathology Configuration" breadcrumbs={breadcrumbs} />
      </div>
      <div className="pathology-container flex flex-col xl:flex-row gap-5 items-start">
        {/* Left-side tabs */}
        <div className="tab-list flex w-full flex-col sm:flex-row xl:flex-col xl:w-64 shrink-0 bg-white border-r border-gray-200 shadow-sm rounded-lg overflow-hidden">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`tab-button w-full text-center xl:text-left py-3 px-2 xl:px-4 text-xs xl:text-sm font-medium text-gray-700 border-b border-gray-200 transition-colors duration-200 ${
                activeTab === tab.name
                  ? "bg-gray-100 text-blue-600 font-semibold"
                  : "hover:bg-gray-50"
              }`}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {/* Right-side content */}
        <div className="content-area flex-grow w-full">
          {tabs.find((tab) => tab.name === activeTab)?.content}
        </div>
      </div>
    </div>
  );
};

export default PathologyConfig;